<!-- 订单管理 二级路由 -->
<template lang="pug">
    div.order-manage
        keep-alive(
            exclude='OrderManageDetail'
        )
            router-view.order-manage-container
</template>
<script>
export default {
    name: 'OrderManage',
    options: {
        needSavedPosition: true,
    },
};
</script>
